import { error, misc, neutral, success } from "../app/themes/colors";
import EnumDataSource from "../utils/enum-data-source.util";

export const PATIENT_PRODUCT_STATUS_REQUESTED = 1;
export const PATIENT_PRODUCT_STATUS_ORDERED = 2;
export const PATIENT_PRODUCT_STATUS_SHIPPED = 3;
export const PATIENT_PRODUCT_STATUS_RECEIVED = 4;
export const PATIENT_PRODUCT_STATUS_CHECKED_IN = 5;
export const PATIENT_PRODUCT_STATUS_DELIVERED = 6;
export const PATIENT_PRODUCT_STATUS_SHIPPED_TO_MANUFACTURER = 7;
export const PATIENT_PRODUCT_STATUS_REPAIR_REQUESTED = 8;
export const PATIENT_PRODUCT_STATUS_CANCELED = 99;
export const PATIENT_PRODUCT_STATUS_EXCHANGED = 998;
export const PATIENT_PRODUCT_STATUS_RETURNED = 999;
export const PATIENT_PRODUCT_STATUS_ON_LOAN = 1000;

const patientProductStatusTypes = {
  [PATIENT_PRODUCT_STATUS_REQUESTED]: "To be Ordered",
  [PATIENT_PRODUCT_STATUS_ORDERED]: "Order Submitted to manufacturer",
  [PATIENT_PRODUCT_STATUS_SHIPPED]: "Shipped from manufacturer",
  [PATIENT_PRODUCT_STATUS_RECEIVED]: "Accepted by Clinic",
  [PATIENT_PRODUCT_STATUS_CHECKED_IN]: "Ready for Delivery",
  [PATIENT_PRODUCT_STATUS_DELIVERED]: "Delivered to Patient",
  [PATIENT_PRODUCT_STATUS_REPAIR_REQUESTED]: "Accepted for Repair",
  [PATIENT_PRODUCT_STATUS_SHIPPED_TO_MANUFACTURER]: "Sent for Repair",
  [PATIENT_PRODUCT_STATUS_CANCELED]: "Canceled",
  [PATIENT_PRODUCT_STATUS_EXCHANGED]: "Exchanged",
  [PATIENT_PRODUCT_STATUS_RETURNED]: "Returned by Patient",
  [PATIENT_PRODUCT_STATUS_ON_LOAN]: "On Loan"
};

export const PATIENT_PRODUCT_STATUSES = new EnumDataSource(
  patientProductStatusTypes
);

export const PATIENT_PRODUCT_STATUS_COLORS: Record<number, string> = {
  [PATIENT_PRODUCT_STATUS_REQUESTED]: error[400],
  [PATIENT_PRODUCT_STATUS_ORDERED]: neutral[500],
  [PATIENT_PRODUCT_STATUS_SHIPPED]: neutral[500],
  [PATIENT_PRODUCT_STATUS_RECEIVED]: error[400],
  [PATIENT_PRODUCT_STATUS_CHECKED_IN]: error[400],
  [PATIENT_PRODUCT_STATUS_DELIVERED]: success[600],
  [PATIENT_PRODUCT_STATUS_REPAIR_REQUESTED]: error[400],
  [PATIENT_PRODUCT_STATUS_SHIPPED_TO_MANUFACTURER]: neutral[500],
  [PATIENT_PRODUCT_STATUS_CANCELED]: neutral[500],
  [PATIENT_PRODUCT_STATUS_RETURNED]: neutral[500],
  [PATIENT_PRODUCT_STATUS_EXCHANGED]: neutral[500],
  [PATIENT_PRODUCT_STATUS_ON_LOAN]: misc.darkYellow
};

export const PATIENT_PRODUCT_STATUS_TRANSITIONS = {
  [PATIENT_PRODUCT_STATUS_REQUESTED]: [
    PATIENT_PRODUCT_STATUS_ORDERED,
    PATIENT_PRODUCT_STATUS_CHECKED_IN,
    PATIENT_PRODUCT_STATUS_DELIVERED,
    PATIENT_PRODUCT_STATUS_CANCELED
  ],
  [PATIENT_PRODUCT_STATUS_ORDERED]: [
    PATIENT_PRODUCT_STATUS_REQUESTED,
    PATIENT_PRODUCT_STATUS_SHIPPED,
    PATIENT_PRODUCT_STATUS_CHECKED_IN,
    PATIENT_PRODUCT_STATUS_DELIVERED,
    PATIENT_PRODUCT_STATUS_CANCELED
  ],
  [PATIENT_PRODUCT_STATUS_SHIPPED]: [
    PATIENT_PRODUCT_STATUS_ORDERED,
    PATIENT_PRODUCT_STATUS_RECEIVED,
    PATIENT_PRODUCT_STATUS_CHECKED_IN,
    PATIENT_PRODUCT_STATUS_DELIVERED,
    PATIENT_PRODUCT_STATUS_CANCELED
  ],
  [PATIENT_PRODUCT_STATUS_RECEIVED]: [
    PATIENT_PRODUCT_STATUS_SHIPPED,
    PATIENT_PRODUCT_STATUS_CHECKED_IN,
    PATIENT_PRODUCT_STATUS_DELIVERED,
    PATIENT_PRODUCT_STATUS_CANCELED
  ],
  [PATIENT_PRODUCT_STATUS_CHECKED_IN]: [
    PATIENT_PRODUCT_STATUS_RECEIVED,
    PATIENT_PRODUCT_STATUS_DELIVERED,
    PATIENT_PRODUCT_STATUS_CANCELED
  ],
  [PATIENT_PRODUCT_STATUS_REPAIR_REQUESTED]: [
    PATIENT_PRODUCT_STATUS_SHIPPED_TO_MANUFACTURER,
    PATIENT_PRODUCT_STATUS_DELIVERED
  ],
  [PATIENT_PRODUCT_STATUS_SHIPPED_TO_MANUFACTURER]: [
    PATIENT_PRODUCT_STATUS_REPAIR_REQUESTED,
    PATIENT_PRODUCT_STATUS_SHIPPED,
    PATIENT_PRODUCT_STATUS_RECEIVED,
    PATIENT_PRODUCT_STATUS_CHECKED_IN,
    PATIENT_PRODUCT_STATUS_DELIVERED
  ]
};
